import React, { useState } from "react";
import CustomButton from "../CutomButton/CustomButton";
import PropertiesModal from "./PropertiesModal";

import { Webchat, WebchatProvider, getClient } from "@botpress/webchat";

const clientId = "eb746b96-6880-4b98-8398-ece72f5e29e6";

const configuration = {
  color: "#f7991c",
  radius: 0.5,
  botAvatar:
    "https://res.cloudinary.com/dkhns25jh/image/upload/v1745583446/gvnxwnapqwzhwhatwvhv.png",
  botName: "Xperience Realty Real Estate",
  shshowPoweredBy: false,
};

export const TabButton = ({ id, name, clicked, setShowPropertiesModal }) => {
  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault();
          setShowPropertiesModal(true);
        }}
        name={id}
        className={`font-[lato] text-white uppercase text-[0.6rem] md:text-sm 2xl:text-lg px-2 py-1 xs:px-4 hover:bg-bhagwa transition-all duration-300 ${
          clicked === id ? "bg-bhagwa" : ""
        } cursor-pointer`}
      >
        {name}
      </span>
    </>
  );
};

export default function TrendingInDubai({ villas, townhouses, apartments }) {
  const [clicked, setIsClicked] = useState(null);
  const [data, setData] = useState(null);

  const [showPropertiesModal, setShowPropertiesModal] = useState(false);

  const client = getClient({
    clientId,
  });

  const [isWebchatOpen, setIsWebchatOpen] = useState(false);

  const toggleWebchat = () => {
    setIsWebchatOpen((prevState) => !prevState);
  };

  const handleClick = (id) => {
    setIsClicked(id);
    if (id === 1) {
      setData(villas);
    }
    if (id === 2) {
      setData(townhouses);
    }
    if (id === 3) {
      setData(apartments);
    }
  };

  return (
    <>
      {/* <div
        style={{
          display: isWebchatOpen ? "flex" : "none",
        }}
        className="inset-0 fixed w-full h-full  backdrop-blur-lg z-[53] flex flex-col items-center justify-center"
        onClick={(e) => {
          e.stopPropagation();
          toggleWebchat();
        }}
      >
        <div
          className="w-full md:w-[70%] lg:w-[60%] xl:max-w-3xl 2xl:max-w-2xl overflow-y-scroll"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{
              display: isWebchatOpen ? "block" : "none",
            }}
          >
            <WebchatProvider client={client} configuration={configuration}>
              <Webchat />
              <div
                className="w-full py-2 bg-white rounded-sm flex flex-row justify-center pr-7 group hover:bg-red-500 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsWebchatOpen(false);
                }}
              >
                <div className="cursor-pointer flex flex-row items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6 text-red-500 group-hover:text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18 18 6M6 6l12 12"
                    />
                  </svg>
                  <span className="text-red-500 group-hover:text-white font-[lato] uppercase">
                    End Chat
                  </span>
                </div>
              </div>
            </WebchatProvider>
          </div>
        </div>
      </div> */}
      <div className="bg-black w-full">
        <div className="max-w-xl 2xl:max-w-3xl  mx-auto ">
          <div className="font-[optima-lt-pro] w-full h-fit py-8 2xl:py-12 flex flex-col justify-center items-center gap-4 2xl:gap-8">
            <h1 className="text-white font-[optima-lt-pro] uppercase text-lg xs:text-xl md:text-3xl 2xl:text-4xl">
              Trending In Dubai Real Estate
            </h1>
            {/* Tab Buttons */}
            <div
              className="bg-white bg-opacity-10 w-3/4 flex flex-row items-center justify-around py-1"
              onClick={(e) => {
                e.stopPropagation();
                handleClick(parseInt(e.target.getAttribute("name")));
              }}
            >
              <TabButton
                id={1}
                name={"Villas"}
                clicked={clicked}
                setShowPropertiesModal={setShowPropertiesModal}
              />
              <TabButton
                id={2}
                name={"Townhouses"}
                clicked={clicked}
                setShowPropertiesModal={setShowPropertiesModal}
              />
              <TabButton
                id={3}
                name={"Apartments"}
                clicked={clicked}
                setShowPropertiesModal={setShowPropertiesModal}
              />
              {/* <TabButton id={4} name={"Developers"} clicked={clicked} /> */}
            </div>
            {/* Input Bar */}
            {/* <div
              className="flex flex-row items-center justify-center w-full"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleWebchat();
              }}
            >
              <input
                disabled={isWebchatOpen}
                type="text"
                className="w-3/4 2xl:w-full h-9 2xl:h-14 bg-white font-[lato] placeholder:uppercase  text-black placeholder:text-black placeholder:text-xs placeholder:opacity-50 2xl:placeholder:text-lg px-2 focus:outline-none focus:ring-2 focus:ring-bhagwa"
                placeholder="Talk to an expert"
              />
              <button className="bg-bhagwa text-white uppercase px-4 pt-1 pb-2 2xl:px-8 2xl:pt-3 2xl:pb-4">
                <span className="text-[0.6rem] md:text-sm 2xl:text-xl align-middle font-[lato]">
                  Chat
                </span>
              </button>
            </div> */}
            {/* Google Review */}
            <div className="flex flex-row items-center gap-1">
              <div>
                <span className="text-[#4285F4] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  G
                </span>
                <span className="text-[#EA4335] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  o
                </span>
                <span className="text-[#FBBC05] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  o
                </span>
                <span className="text-[#4285F4] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  g
                </span>
                <span className="text-[#34A853] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  l
                </span>
                <span className="text-[#EA4335] font-[lato] text-xl md:text-3xl 2xl:text-5xl">
                  e
                </span>
              </div>
              <div className="text-white font-[lato] text-xl md:text-3xl 2xl:text-5xl px-2 py-1">
                4.9
              </div>
              <div className="flex text-yellow-400 text-base 2xl:text-3xl">
                {"★".repeat(5)}
              </div>
            </div>
            {/* See All Reviews Button */}
            <div className="w-1/2 md:w-[50%]">
              <CustomButton
                name={"View All Reviews"}
                link={"/customer-reviews/"}
              />
            </div>
          </div>
        </div>
      </div>
      {showPropertiesModal && (
        <PropertiesModal
          data={data}
          setShowPropertiesModal={setShowPropertiesModal}
          setIsClicked={setIsClicked}
        />
      )}
    </>
  );
}
